<template>
  <div class="m">
    <van-popup v-model="ishow" position="left" :style="{ width: '100%', height: '100%' ,   }">
      <div class="equit">
        <!--close-->
        <div class="close" @click="closeEquiment">
          <img src="../../assets/images/close.png" />
        </div>
        <!--close end-->
        <!--用户头像-->
        <div class="equtx">
          <div class="equtx_img">
            <img src="../../assets/images/tx.png" />
          </div>
          <div class="equtx_name fs32">{{ $t('live.device_name') }}</div>
        </div>
        <!--用户头像 end-->
        <!--当前选择设备-->
        <div class="equlist equlist1">
          <div class="equlist_title fs24">{{ $t('live.thre_now') }}</div>
          <div class="equm">
            <div class="mequs" v-for="(item, index) in 1" :key="index">
              <div class="mequ">
                <p class="p1 fs30">{{ choselist.deviceName }}</p>
                <p class="p2 fs24">{{ $t('live.code') }}：{{ choselist.no }}</p>
              </div>
            </div>
          </div>

          <!-- 搜索设备 -->
          <div class="searchDevice">
            <van-field placeholder="搜索设备" @input="handleInput" maxlength="15" v-model="text" />
          </div>
        </div>
        <!--当前选择设备 end-->
        <!--其他设备-->
        <div class="equlist equlist2">
          <div class="equlist_title fs24">
            {{ $t('live.thre_more') }}({{ devicelist.length - 1 }})
          </div>
          <div class="equm" id="equlist_wrap" ref="equlist_wrap" :style="'height:' + listheight + 'px'">
            <div class="mequs" v-for="(item, index) in devicelist" :key="index" v-show="choselist.no != item.no">
              <div class="mequ" @click="getThre(item.no, item.deviceName)">
                <p class="p1 fs30">{{ item.deviceName }}</p>
                <p class="p2 fs24">{{ $t('live.code') }}：{{ item.no }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--其他设备 end-->
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data () {
    return {
      choselist: '',
      devicelist: [],
      listheight: 0,
      oladDevicelist: [],
      text: '',
    }
  },
  props: {
    dontSaveNo: {
      type: Boolean,
      default: false,
    },
    ishow: {
      type: Boolean,
      default: false,
    },
    des: {
      type: Number,
      default: 0,
    },
  },
  created () {
    // window.addEventListener('scroll', function (e) {
    //   console.log(e)
    // })
  },

  watch: {
    ishow (bl) {
      if (bl) {
        setTimeout(() => {
          const dom = document.getElementById('equlist_wrap')
          const top = sessionStorage.getItem('deviceScrollTop')
          console.log('top:', top, this.$refs.equlist_wrap)
          // 如果有滚动高度 则设置滚动高度

          setTimeout(() => {
            console.log('1')
            this.$refs.equlist_wrap.scrollTop = top
          }, 0)

          dom.addEventListener(
            'scroll',
            (e) => {
              const scrollTop = e.target.scrollTop
              this.$debounce(() => {
                sessionStorage.setItem('deviceScrollTop', scrollTop)
              })()
            },
            true,
          )
        }, 0)
      }
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.getDomHight()
    })
  },

  methods: {
    getDomHight () {
      //屏幕可视区宽度
      let w = document.documentElement.clientWidth
      let h = document.documentElement.clientHeight
      let h1 = (205 * 414) / 750 //2.05rem
      let h2 = (187 * 414) / 750 + 2 //0.67rem 1.2rem
      let h3 = (87 * 414) / 750
      let lh = h - h1 - h2 - h3
      this.listheight = lh
    },

    closeEquiment () {
      this.$emit('child-event', this.choselist.no)
    },

    // 设备展示
    setDeviceList (choselist, devicelist,) {

      this.choselist = choselist
      this.devicelist = [...devicelist]
      this.oladDevicelist = [...devicelist]

      if (this.dontSaveNo) return

      localStorage.setItem('no', choselist.no)
      localStorage.setItem('dname', choselist.deviceName)

    },

    //单个设备点击
    getThre (no, dname) {
      //记录点击的设备号
      this.$emit('child-event', no)

      if (this.dontSaveNo) return

      localStorage.setItem('no', no)
      localStorage.setItem('dname', dname)
    },

    // 搜索
    handleInput (val) {
      this.$debounce(() => {
        if (val) {
          const list = []
          this.oladDevicelist.map((item) => {
            const index = item.deviceName.indexOf(val)
            if (index > -1) {
              list.push(item)
            }
          })

          this.devicelist = [...list]
        } else {
          this.devicelist = [...this.oladDevicelist]
        }
      })()
    },
  },
}
</script>
<style>
/*侧滑层*/
.equit {
  position: relative;
}
.close {
  position: absolute;
  top: 0.2rem;
  right: 0.15rem;
}
.close img {
  width: 0.29rem;
  height: 0.29rem;
  vertical-align: text-top;
}
.equtx {
  overflow: hidden;
  padding: 0px 0.2rem 0.1rem;
}
.equtx .equtx_img,
.equtx .equtx_img img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 999px;
}
.equtx .equtx_name {
  padding-left: 60px;
  line-height: 50px;
  font-size: 18px;
  font-weight: 700;
}
.equlist {
  margin: 0 auto;
}
.equlist .equlist_title {
  height: 20px;
  line-height: 20px;
  color: #000;
  padding: 10px 0 0px 0;
  border-bottom: 1px solid #f4f4f4;
  font-weight: 700;
}
.equlist.equlist1 {
  padding: 0 10px;
}
.equlist.equlist1 .mequs {
  background: url(../../assets/images/seb1.png) no-repeat 10px center;
  background-size: 20px auto;
}
.equlist.equlist2 .mequs {
  background: url(../../assets/images/seb2.png) no-repeat 10px center;
  background-size: 20px auto;
}
.mequs {
  border-bottom: 1px solid #f4f4f4;
  padding: 10px 0 10px 40px;
}

.mequ {
  height: 0.8rem;
}
.mequ .p2 {
  padding-top: 0.05rem;
}
.equlist.equlist1 .mequs {
  border: 1px solid rgba(40, 85, 187, 0.5);
  border-radius: 0.15rem;
  background-color: rgba(40, 85, 187, 0.05);
}
.equlist.equlist1 .mequ {
  background: url(../../assets/images/gou.png) 5.5rem 50% no-repeat;
  background-size: 0.3rem 0.22rem;
}
.equlist.equlist1 .mequ .p1 {
  color: #2855bb;
  font-size: 14px;
  font-weight: 700;
}
.equlist.equlist1 .mequ .p2 {
  color: #517cdc;
  font-size: 12px;
}
.equlist.equlist2 {
  margin-top: 0.2rem;
  padding: 0 0 0 10px;
}
.equlist.equlist2 .equm {
  /* overflow: overlay; */
  overflow-y: scroll;
}
.equlist.equlist2 .mequ .p1 {
  color: #666;
  font-size: 14px;
  font-weight: 700;
}
.equlist.equlist2 .mequ .p2 {
  color: #999;
  font-size: 12px;
}
.equlist.equlist2 .mequs {
  padding: 10px 0 10px 60px;
}
/*侧滑层 end*/

/* 搜索设备 */
.searchDevice {
  width: 100%;
  height: 60px;
  border: 1px solid rgba(40, 85, 187, 0.5);
  box-sizing: border-box;
  border-radius: 0.15rem;
  overflow: hidden;
  margin-top: 5px;
}

.van-field,
.van-field__body,
.van-field__control {
  height: 100%;
}
</style>


<style scoped lang="scss">
::v-deep .van-popup {
  overflow: hidden;
}
</style>
